// extracted by mini-css-extract-plugin
export default {"fieldWidth":"createCollectionGroup_fieldWidth__iXlZe","form":"createCollectionGroup_form__iAAdM","top":"createCollectionGroup_top__cnk9r"};